import { render, staticRenderFns } from "./ChargeRule.vue?vue&type=template&id=24d5f350&scoped=true&"
import script from "./ChargeRule.vue?vue&type=script&lang=js&"
export * from "./ChargeRule.vue?vue&type=script&lang=js&"
import style0 from "./ChargeRule.vue?vue&type=style&index=0&id=24d5f350&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5f350",
  null
  
)

export default component.exports